import React from 'react';

import {HighlightedText} from 'src/modules/entitlements/components/main-column';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';
import Loading from '@pb/kit-component-loading';


import {NO_RESULTS_MESSAGE, UNCLEAR_QUERY_MESSAGE} from './constants';

import type {ResourceSearchItem} from 'src/openapi/admin/models/ResourceSearchItem';
import type {ServerResponse} from 'src/typedef';

type Props = {
    id: string,
    busy: boolean,
    query: string,
    response: ServerResponse<ResourceSearchItem[]> | null,
    selectedResources: string[],
};

export const AddResourceSuggestResult = ({busy, query, response, id, selectedResources}: Props) => {
    if (query.length < 2) {
        return (
            <div id={id} className="pd-s">
                {UNCLEAR_QUERY_MESSAGE}
            </div>
        );
    }

    if (busy) {
        return (
            <div id={id} className="pd-s">
                <Group><Loading type="ICON"/> Loading</Group>
            </div>
        );
    }

    if (response?.data?.length) {
        return (
            <div id={id}>
                {response.data.map(resource => (
                    <AutosuggestItem key={resource.id} value={resource.id}>
                        {itemProps => (
                            <Item grow={1}>
                                <Group justify="space-between" alignItems="center">
                                    <div style={{width: 400}}>
                                        <EllipsisTextHint title={resource.name}>
                                            {itemProps.highlighted ? resource.name : (
                                                <HighlightedText
                                                    text={resource.name.toLowerCase()}
                                                    highlightedText={query.toLowerCase()}
                                                />
                                            )}
                                        </EllipsisTextHint>
                                    </div>
                                    {selectedResources.includes(resource.id) && <Icon type={Icons.CHECK}/>}
                                </Group>
                            </Item>
                        )}
                    </AutosuggestItem>
                ))}
            </div>
        );
    }

    if (response?.data && !response.data.length) {
        return (
            <div id={id} className="pd-s">
                {NO_RESULTS_MESSAGE}
            </div>
        );
    }

    if (response?.error) {
        return (
            <div id={id} className="pd-s">
                {response.error.message}
            </div>
        );
    }

    return null;
};
